import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Topbar from '../PulseSurvey/Topbar';
import instantSupportTick from '../../assets/images/instant-support-tickmark.svg';
import { CompanyApi } from '../../api/companyApi';
import Loader from '../../component/common/Loader';
import { shoorahBenefitsPageData as mainPageData } from '../../utils/pageContent';

const ViewBenefitsPage = () => {
  const pageData = mainPageData.viewBenefitsPageData;
  // const [showCustomPlans, setShowCustomPlans] = useState(false);
  // const [customPlanData, setCustomPlanData] = useState(null);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);

  // const handleCustomPlansToggle = () => {
  //   setShowCustomPlans((prev) => !prev);
  // };

  const plansData = pageData.plansData;

  // const fetchCustomPlans = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await CompanyApi.viewCustomPlansBenefits();
  //     if (response?.data?.meta?.code === 1) {
  //       setCustomPlanData(response?.data?.data);
  //     } else {
  //       setCustomPlanData({});
  //     }
  //   } catch (error) {
  //     console.error('Failed to fetch custom plans:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    // fetchCustomPlans();
    setPlans(plansData);
  }, []);

  // useEffect(() => {
  //   if (showCustomPlans) {
  //     setPlans(customPlanData?.plans || []);
  //   } else {
  //     setPlans(plansData);
  //   }
  // }, [showCustomPlans, customPlanData]);

  return (
    <div className="relative lg:pl-5 lg:mb-[45px]">
      {loading && <Loader />}
      <Helmet>
        <meta charSet="utf-8" />
        <title>{pageData.metaTitle}</title>
      </Helmet>

      <Topbar
        title={pageData.pageTitle}
        hasDesc={true}
        description={pageData.pageDescription}
        infoBtn={false}
      />

      {/* Toggle button */}
      {/* <div className="flex items-center gap-3 mt-5">
        <label className="flex items-center gap-2 text-sm font-medium text-gray-700 dark:text-gray-300">
          <span>{showCustomPlans ? pageData.showingCustomPlansTitle : pageData.showCustomPlansTitle}</span>
          <div
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 cursor-pointer ${
              showCustomPlans ? 'bg-shoorah-primary' : 'bg-gray-200'
            }`}
            onClick={handleCustomPlansToggle}
            role="switch"
            aria-checked={showCustomPlans}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                showCustomPlans ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </div>
        </label>
      </div> */}

      <div className="flex flex-col w-full max-w-4xl mt-5 bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl my-5 lg:p-6 p-4 pb-8">
        <div className="flex flex-col sm:flex-row mb-2 justify-between">
          <p className="text-xl font-medium text-gray-900 dark:text-white">{pageData.listOfBenefitsPlansTitle}</p>
        </div>

        {/* Loading state */}
        {loading && <p className="text-center my-4 text-gray-600 dark:text-gray-300">{pageData.laodingText}</p>}

        {/* Empty state */}
        {!loading && plans?.length === 0 && (
          <p className="text-center my-4 text-gray-500 dark:text-gray-400">
            {pageData.noBenefitsAvailableText}
          </p>
        )}

        {/* Plan list */}
        {!loading &&
          plans?.map((data, index) => (
            <div
              key={index}
              className="w-full mx-auto mt-6 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden"
            >
              <div className="divide-y divide-gray-200 dark:divide-gray-700">
                <div className="hover:bg-gray-50 dark:hover:bg-gray-800 px-4 sm:px-6 py-3 sm:py-4">
                  <label className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3">
                    <div className="flex items-center w-full sm:w-auto">
                      <span className="font-medium text-gray-900 dark:text-white ml-2 sm:ml-3">
                        {data?.title}
                      </span>
                    </div>
                  </label>
                </div>

                <div className="px-8 py-4">
                  <p className="text-gray-700 dark:text-gray-300">{data?.description}</p>

                  {data?.planRequirements?.length > 0 && (
                    <div className="mt-4">
                      <h4 className="text-gray-900 dark:text-gray-300 font-medium mb-2">
                        {pageData.informationTitle}
                      </h4>
                      {data.planRequirements.map((text, idx) => (
                        <div key={idx} className="flex items-start my-3 text-xs sm:text-sm">
                          <img
                            src={instantSupportTick}
                            alt="Tick"
                            className="w-[20px] sm:w-[24px] h-[20px] sm:h-[24px] dark:invert mr-2"
                          />
                          <span className="text-[#606060] dark:text-gray-300">{text}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}

        {/* Contact us button */}
        <button
          className="w-full sm:w-[150px] p-2 mt-4 text-sm font-normal rounded-full border shadow-sm bg-shoorah-active dark:bg-shoorah-secondary text-white cursor-pointer border-shoorah-active"
          onClick={() => (window.location.href = 'mailto:info@shoorah.io')}
        >
          {pageData.contactUsBtnText}
        </button>
      </div>
    </div>
  );
};

export default ViewBenefitsPage;
